import { Outlet } from 'react-router-dom';

export function PublicLayout() {
  return (
    <div className="min-h-full gradient-bg">
      <header className="border-b border-[var(--border-subtle)] px-6 py-4">
        <div className="mx-auto flex max-w-6xl items-center justify-between">
          <span className="text-lg font-semibold">SCUBE Agentic AI</span>
          <nav className="flex items-center gap-4 text-sm text-secondary">
            <a href="/public/pricing" className="hover:text-[var(--text-primary)]">
              Pricing
            </a>
            <a href="/public/register" className="hover:text-[var(--text-primary)]">
              Register
            </a>
            <a href="/public/login" className="hover:text-[var(--text-primary)]">
              Login
            </a>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-10">
        <Outlet />
      </main>
      <footer className="border-t border-[var(--border-subtle)] px-6 py-6 text-center text-sm text-secondary">
        © SCUBE Infotech
      </footer>
    </div>
  );
}
